import { RefreshCw, ShieldAlert } from 'lucide-react';
import { Button } from '../ui/Button';

/**
 * Estado VISIBLE cuando la herramienta pide una primitiva de captura que esta
 * versión de la app no tiene registrada (deuda D5d de la auditoría C3): antes
 * la zona de captura quedaba EN BLANCO y el payload caía a `posicion`.
 * Recargar trae el build nuevo si ya se desplegó (el SW se auto-actualiza).
 */
export function CapturaNoSoportada({ tipoCrudo }: { tipoCrudo: string | null }) {
  return (
    <div
      role="status"
      className="flex flex-col items-center gap-3 rounded-lg border border-warning bg-surface-raised px-4 py-6 text-center"
    >
      <ShieldAlert className="h-8 w-8 text-warning" aria-hidden="true" />
      <p className="font-display text-base font-semibold text-content">
        Esta actividad todavía no se puede mostrar aquí
      </p>
      <p className="font-sans text-sm text-content-muted">
        La actividad pide una forma de participar
        {tipoCrudo ? ` («${tipoCrudo}»)` : ''} que esta versión de la aplicación
        aún no sabe mostrar. Recargá la página; si sigue igual, avisale a quien
        facilita la sesión.
      </p>
      <Button
        variant="secondary"
        onClick={() => window.location.reload()}
        leadingIcon={<RefreshCw className="h-4 w-4" aria-hidden="true" />}
      >
        Recargar la página
      </Button>
    </div>
  );
}
